import React from "react";
import GenericSearchableDropdown, {
  type DropdownItem,
} from "@ui-components/Dropdown/GenericSearchableDropdown";

export interface TagNameDropdownProps {
  value: string;
  onChange: (value: string) => void;
  tagOptions?: DropdownItem[];
  isLoadingTags?: boolean;
  tagEmptyMessage?: string;
  allowCustomTagValues?: boolean;
  disabled?: boolean;
  defaultLabel?: string;
}

const TagNameDropdown: React.FC<TagNameDropdownProps> = ({
  value,
  onChange,
  tagOptions = [],
  isLoadingTags = false,
  tagEmptyMessage = "No tags available",
  allowCustomTagValues = false,
  disabled = false,
  defaultLabel = "Select tag...",
}) => (
  <GenericSearchableDropdown
    items={tagOptions}
    value={value}
    onSelect={onChange}
    defaultLabel={defaultLabel}
    size="input"
    widthClass="w-full"
    className="w-full"
    minWidthClass=""
    maxWidthClass=""
    disabled={disabled || isLoadingTags}
    loading={isLoadingTags}
    emptyItemsMessage={isLoadingTags ? "Loading tags..." : tagEmptyMessage}
    allowCustomValues={allowCustomTagValues}
  />
);

export default TagNameDropdown;
